import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Errored from '../Errored';
import Loading from '../Loading';
import { makeCancelable } from '../utils/utils';
import GS from '../../grafsync/grafsync';
import { NS_GS } from '../utils/constants';
import SettingsEditor from './SettingsEditor';

class SettingsManager extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoadingSettings: true,
      isErrored: false
    };
    this.cancellable = null;
  }

  componentDidMount() {
    this.doSearch({
      search: [{
        predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        value: NS_GS + "Setting"
      }],
      graph: [GS.getActiveSubscription()],
      page: 1,
      noCount: true
    })
      .promise
      .then(data => {
        const settings = data.results[0];
        this.setState({ settings, isLoadingSettings: false });
      })
      .catch((e) => {
        if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
      });
  }

  doSearch(payload) {
    this.cancellable = makeCancelable(GS.search(payload));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  render() {

    const { isLoadingSettings, isErrored, settings } = this.state;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoadingSettings) return <Loading />;

    return (
      <SettingsEditor id={settings.id} graph={settings.inNamedGraph} />
    );
  }
}

SettingsManager.propTypes = {
  classes: PropTypes.object
};

export default SettingsManager;